import { render, staticRenderFns } from "./FeaturedImage.vue?vue&type=template&id=e32a2596&scoped=true&"
import script from "./FeaturedImage.vue?vue&type=script&lang=ts&"
export * from "./FeaturedImage.vue?vue&type=script&lang=ts&"
import style0 from "./FeaturedImage.vue?vue&type=style&index=0&id=e32a2596&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32a2596",
  null
  
)

export default component.exports